/*
 * @Description: 自动生成代码无需修改，可跑npm run services来重新生成
 */
import http from '@lib/http';
import { GetServerSidePropsContext } from 'next';

export interface Query {
  /**
   * 活动id
   */
  event_id: unknown;
  /**
   * 嘉宾图片类型，图片类型origin, small, mid，默认origin
   */
  guest_image_type: unknown;
  /**
   * 日程图片类型，图片类型origin, small, mid，默认origin
   */
  scheduler_pic_image_type: unknown;
  temp_token?: string;
  source?: number;
}
export type SchedulerDataList = {
  schedule_status: any;
  /**
   * 日程名字
   */
  name: string;
  /**
   * 开始时间戳（秒）
   */
  begin_time: number;
  /**
   * 结束时间戳（秒）
   */
  end_time: number;
  /**
   * 图片列表，只有一个元素
   */
  pics_source_list?: {
    cos_id: string;
    url: string;
  }[];
  plans?: {
    /**
     * 议题名称
     */
    title: string;
    /**
     * 开始时间戳，精确到秒
     */
    begin_time: number;
    /**
     * 结束时间戳，精确到秒
     */
    end_time: number;
    description: string;
  }[];
  /**
   * 日程介绍
   */
  description: string;
  /**
   *  日程id
   */
  scheduler_id: number;
  /**
   * 场地类型，1：大型会场
   */
  venue_type: number;
  guests?: {
    /**
     * 头像url
     */
    url: string;
    /**
     * 头像id
     */
    photo_cosId: string;
    /**
     * 嘉宾id
     */
    id: string;
    /**
     * 嘉宾名称
     */
    name: string;
    /**
     * 嘉宾职称
     */
    position: string;
    /**
     * 嘉宾公司
     */
    company: string;
    /**
     * 嘉宾介绍
     */
    introduction: string;
    /**
     * 嘉宾权重
     */
    sort_weight: number;
  }[];
  hosts?: {
    id: string;
    name: string;
  }[];
  /**
   * 是否允许观众观看录制回放
   */
  is_allow_replay: boolean;
  /**
   * 会议id
   */
  meeting_id: string;
  /**
   * 会议code
   */
  meeting_code: string;
  /**
   * 回放url
   */
  meeting_url: string;
}[];
export interface PublicRegistrationQueryEventSchedulersRes {
  nonce: string;
  data: Data;
  code: number;
  msg: string;
}
export interface Data {
  scheduler_data_list: SchedulerDataList;
}

const PublicRegistrationQueryEventSchedulers = async (data: Query, ctx?: GetServerSidePropsContext) => {
  const res = await http.get<PublicRegistrationQueryEventSchedulersRes>(
    '/wemeet-tapi',
    '/v2/activities/public/registration/query-event-schedulers',
    data,
    ctx,
  );

  return res;
};

export default PublicRegistrationQueryEventSchedulers;
